<template>
  <div>
    <div class="toolbar">
      <el-form :inline="true" :model="q" size="mini">
        <el-form-item label="统计日期">
          <el-date-picker
            v-model="q.time_range"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="daterange"
            :picker-options="pickerOptions"
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item v-if="this.$store.getters.userinfo.agency_type == 2" label="所属子代:">
          <more-selete
            ref="moreSelect_agency"
            :dataList="AgencyList"
            showName="user_name"
            v-model="q.agency_ids"
            placeholder="请选择"
          ></more-selete>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="query">查询</el-button>
          <el-button type="danger" @click="reload">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row style="margin-bottom: 10px" type="flex" class="table-btns" justify="end">
      <el-button
        size="mini"
        @click="asyncRecord"
        type="warning"
      >异步导出记录</el-button>
      <el-button
        size="mini"
        @click="downloadData"
        type="primary"
        :loading="downloading"
        icon="el-icon-printer"
        style="float: right"
      >异步导出</el-button>
    </el-row>
    <el-table
      :data="listData.items"
      v-loading.body="listLoading"
      @sort-change="sortlist"
      size="mini"
      :height="listData.total>25?'65vh':null"
      stripe
      border
      fit
      highlight-current-row
    >
      <el-table-column prop="day" label="日期" width="110"></el-table-column>
      <el-table-column prop="agency_id" label="所属子代" width="110">
        <template slot-scope="scope">{{scope.row.agency_name}}</template>
      </el-table-column>
      <el-table-column prop="agency_recharge_success_count" label="充值次数" width="110"></el-table-column>
      <el-table-column prop="agency_recharge_success_amount" label="充值金额" width="110">
        <template
          slot-scope="scope"
        >{{(Number(scope.row.agency_recharge_success_amount)/10000).toFixed(4)}}</template>
      </el-table-column>
      <el-table-column prop="agency_recharge_chase_count" label="充值追分次数" width="120"></el-table-column>
      <el-table-column prop="agency_recharge_chase_amount" label="充值追分金额" width="120">
        <template
          slot-scope="scope"
        >{{(Number(scope.row.agency_recharge_chase_amount)/10000).toFixed(4)}}</template>
      </el-table-column>
      <el-table-column prop="actual_agency_recharge_success_amount" label="实际充值金额" width="120">
        <template
          slot-scope="scope"
        >{{(Number(scope.row.actual_agency_recharge_success_amount)/10000).toFixed(4)}}</template>
      </el-table-column>
      <!-- <el-table-column prop="user_agency_chat_user_count" label="聊天人数" width="120"></el-table-column> -->
      <el-table-column prop="user_recharge_success_user_count" label="上分人数" width="120"></el-table-column>
      <el-table-column prop="user_recharge_success_count" label="上分次数" width="120"></el-table-column>
      <el-table-column prop="user_recharge_chase_amount" label="上分金额" width="120">
        <template
          slot-scope="scope"
        >{{(Number(scope.row.user_recharge_success_amount)/10000).toFixed(4)}}</template>
      </el-table-column>
      <el-table-column prop="user_recharge_chase_count" label="追分次数" width="120"></el-table-column>
      <el-table-column prop="user_recharge_chase_amount" label="追分金额" width="120">
        <template
          slot-scope="scope"
        >{{(Number(scope.row.user_recharge_chase_amount)/10000).toFixed(4)}}</template>
      </el-table-column>
      <el-table-column prop="user_recharge_chase_amount" label="追分失败金额" width="120">
        <template
          slot-scope="scope"
        >{{(Number(scope.row.user_recharge_chase_failed_amount)/10000).toFixed(4)}}</template>
      </el-table-column>
      <el-table-column prop="user_recharge_chase_amount" label="实际上分金额" width="120">
        <template
          slot-scope="scope"
        >{{(Number(scope.row.actual_user_recharge_success_amount)/10000).toFixed(4)}}</template>
      </el-table-column>
      <el-table-column prop="user_recharge_complain_count" label="投诉次数" width="120"></el-table-column>
      <el-table-column prop="user_recharge_bad_comment_count" label="差评次数" width="120"></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="q.page_no"
        :page-sizes="$store.state.app.pageSizeArr"
        :page-size="q.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listData.total"
      ></el-pagination>
    </div>
    <exportTable ref="recordDialog" />
  </div>
</template>

<script>
import MoreSelete from "@/components/MoreSelete/index";
import { getReportList, getAgencyList, getAgencyInfo } from "@/api";
import { queryFilter } from "@/utils/patch";
import timedate from "@/utils/timedate.js";
import downloadExcel from "@/utils/downloadExcel";
import exportTable from "@/components/exportTable";

export default {
  components: { MoreSelete, exportTable},
  data() {
    return {
      listData: {},
      q: {
        page_size: 30,
        page_no: 1,
        order_by: "-day",
        parent_ids:
          this.$store.getters.userinfo.agency_type == 2
            ? [String(this.$store.getters.userinfo.id)]
            : [],
        agency_ids:
          this.$store.getters.userinfo.agency_type == 1
            ? [String(this.$store.getters.userinfo.id)]
            : [],
        agency_type: 1,
        time_range: [timedate.dateWeekHMS, timedate.dateTodayHMS]
      },
      listLoading: false,
      showUpdate: false,
      show_id: null,
      MerchantsList: [],
      AgencyMainList: [],
      AgencyList: [],
      userType: this.$store.state.app.userType,
      dailyList: [],
      downloading: false,
      restInit: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateTodayHMS,
                timedate.dateTodayHMS
              ]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateYesterdayHMS,
                timedate.dateYesterdayHMS
              ]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateWeekHMS,
                timedate.dateTodayHMS
              ]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              picker.$emit("pick", [
                timedate.dateOneMonthHMS,
                timedate.dateTodayHMS
              ]);
            }
          }
        ]
      }
    };
  },
  activated() {
    this.getAgencyInfo().then(() => {
      this.getList();
      this.getChildAgencyList();
    });
  },
  deactivated() {
    this.listLoading = false;
  },
  methods: {
    getAgencyInfo() {
      return new Promise(resolve => {
        getAgencyInfo().then(res => {
          if (res.status === 0) {
            if (res.data.agency_type == 1) {
              this.q.agency_ids = [String(res.data.id)];
              this.q.agency_type = 1;
            }
            if (res.data.agency_type == 2) {
              this.q.parent_ids = [String(res.data.id)];
              this.q.agency_type = 1;
            }
            resolve();
          }
        });
      });
    },

    asyncRecord() {
      this.$refs.recordDialog.open('NORMAL_AGENCY_STATS');
    },

    downloadData() {
      this.downloading = true;

      let query = {};
      const agency_ids = this.q.agency_ids || [];

      Object.assign(query, this.q, {
        parent_ids: JSON.stringify(this.q.parent_ids),
        agency_ids: JSON.stringify(agency_ids),
        export: 1
      });
      query = this.$dateFilter({
        data: query,
        range: "time_range",
        start: "created_at_begin",
        end: "created_at_end"
      });
      query = queryFilter(query);

      getReportList(query)
        .then(res => {
          if (res.status === 0) {
            this.$message({
              type: 'success',
              message: '异步导出耗时较长，请稍后至异步导出记录下载',
              duration: 3000
            })
            this.downloading = false;
          }
        }).catch(() => {
          this.downloading = false;
        });
    },

    getAgencyList() {
      getAgencyList({ agency_type: 2, page_size: 1000 }).then(res => {
        if (res.status === 0) {
          this.AgencyMainList = res.data.items;
        }
      });
    },
    getChildAgencyList() {
      getAgencyList({ agency_type: 1, page_size: 1000 }).then(res => {
        if (res.status === 0) {
          this.AgencyList = res.data.items;
        }
      });
    },
    sortlist(sort) {
      if (sort.order === "descending") {
        this.q.order_by = "-" + sort.prop;
      } else if (sort.order === "ascending") {
        this.q.order_by = sort.prop;
      } else {
        this.q.order_by = "-day";
      }
      this.getList();
    },
    add() {
      this.show_id = null;
      this.showUpdate = true;
    },
    update(row) {
      this.show_id = row.id;
      this.showUpdate = true;
    },
    remove() {},
    query() {
      this.q = Object.assign(this.q, { page_no: 1, page_size: 30 });
      this.getList();
    },
    reload() {
      this.restInit = false;
      this.$nextTick(() => (this.restInit = true));
      this.q = {
        page_size: 30,
        page_no: 1,
        order_by: "-day",
        parent_ids:
          this.$store.getters.userinfo.agency_type == 2
            ? [String(this.$store.getters.userinfo.id)]
            : [],
        agency_ids:
          this.$store.getters.userinfo.agency_type == 1
            ? [String(this.$store.getters.userinfo.id)]
            : [],
        time_range: [timedate.dateWeekHMS, timedate.dateTodayHMS],
        agency_type: 1
      };
      this.getList();
    },
    handleSizeChange(val) {
      this.q.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.q.page_no = val;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.getList();
    },
    getList() {
      let query = {};
      const agency_ids = this.q.agency_ids || [];

      Object.assign(query, this.q, {
        parent_ids: JSON.stringify(this.q.parent_ids),
        agency_ids: JSON.stringify(agency_ids)
      });
      query = this.$dateFilter({
        data: query,
        range: "time_range",
        start: "created_at_begin",
        end: "created_at_end"
      });
      query = queryFilter(query);
      getReportList(query).then(res => {
        if (res.status === 0) {
          this.listData = {};
          this.listLoading = false;
          this.listData = res.data;
        }
      });
    }
  },
  watch: {}
};
</script>
